
import ui from '~/ZenOne-StoryBook/mixins/ui'
import { completeWizard } from '~/helpers/practiceLocation'
import { onSetInitDefaultFiltersCatalogLocalStorage } from '~/helpers/onSetInitDefaultFiltersCatalogLocalStorage'


export default {
  name: 'RegistrationStepSix',
  components: {},
  mixins: [ui],
  data() {
    return {
      checkbox: true,
    }
  },
  mounted() {},
  watch: {
    checkbox: {
      handler(v) {
        this.$emit('validation', v)
      },
      immediate: true
    }
  },
  methods: {
    showTermsAndConditionsDialog() {
      this.$ga.event({
        eventCategory: 'registration',
        eventAction: 'click',
        eventLabel: 'terms and conditions btn',
        eventValue: 1
      })
      this.$emit('showTerms')
    },
    async nextBtnClickHandler() {
      this.showFSLoader()

      await completeWizard(this.$axios, this.$store)

      await this.$store.dispatch('user/SetUserPracticeLocation')

      onSetInitDefaultFiltersCatalogLocalStorage()

      this.hideFSLoader()

      await this.$router.push('/')
    }
  }
}
